import axios from 'axios'

var Dominio = "https://api.finlev.tec.br/";
//var Dominio = "http://api.finlev.com.br/";
if (document.location.hostname == "localhost"){
  Dominio = "http://localhost:8086/";
}


export default {
    ler(caminho, parametros) {
        return axios(
          {
            method: 'post',
            headers:{
              'Content-Type':'application/x-www-form-urlencoded;charset=utf-8',
            },
            url: Dominio + caminho, 
            data : '='+JSON.stringify(parametros),
          }
          );
    }
}
